$(function() {

	scrollFunction();

	// Side Menu Control
	var myDir = ($("html").attr('dir') == 'rtl' ? 'right' : 'left');
	var mySlidebars = new $.slidebars();
	$('.mobile-menu-btn').on('click', function() {
		mySlidebars.slidebars.toggle(myDir);
	});

	$(window).on("scroll", scrollFunction);

	var bHeight = $('.wrapper-banners').height() - $('.header-desktop').height();
	function scrollFunction() {
		if ($(window).scrollTop() > bHeight) {
			$(".main-header").addClass("scrolling");
		} else {
			$(".main-header").removeClass("scrolling");
		}
	}

	// // scroll to id

	// $("a[rel='m_PageScroll2id']").mPageScroll2id({
	// 	offset: 80
	// });

	// drop menu

	// $('.drop-menu__ul li a').mouseenter(function(e) {
	// 	// e.preventDefault();
	// 	$(this).tab('show');
	// })

	// $('.drop-menu__ul li').mouseleave(function(e) {
	// 	$(this).removeClass('active');
	// })


});